import { UUID } from 'crypto';
import { requireApp } from 'store/assertions';

const getApiClient = () => requireApp().apiClient;
const getGridId = () => requireApp().gridId;

export type SavedStateSummary = {
    id: UUID;
    gridId: UUID;
    name: string | null;
};

type PersistedStatePayload = {
    version: number;
    state: unknown;
    bucketVersions?: unknown;
};

const buildStatesPath = (suffix = ''): string => `grids/${getGridId()}/states${suffix}`;

export async function listStates(): Promise<SavedStateSummary[]> {
    const response = await getApiClient().get<SavedStateSummary[]>(buildStatesPath());
    return response.data;
}

export async function createState(name: string, state: PersistedStatePayload): Promise<SavedStateSummary> {
    const response = await getApiClient().post<SavedStateSummary>(buildStatesPath(), {
        name,
        state,
    });
    return response.data;
}

export async function downloadState(stateId: UUID): Promise<unknown> {
    const response = await getApiClient().get<unknown>(buildStatesPath(`/${stateId}/state`));
    return response.data;
}
